var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZToA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#2a374e;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-406 -200)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2217 3798)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-1811 -3598)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1808.75 -3595.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.026 7.903)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.255,0h-.8L1.5,5.6H2.61L2.9,4.756h1.88l.29.841H6.186ZM3.272,3.705l.579-1.654.571,1.654Z",
    transform: "translate(-1.496)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.461 13.488) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M269.343,9.479l-2,2V0H266.3V11.476l-2-2-.743.743,3.266,3.266,3.266-3.266Z",
    transform: "translate(-263.555)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.281,299.247H.5V300.3H3.7l-3.2,3.72v.825h4.73v-1.051H2.08l3.2-3.72Z",
    transform: "translate(-0.499 -299.247)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZToA);
export default __webpack_public_path__ + "static/media/zToA.c7a0619319c8f65c6acef05de8b9c7aa.svg";
export { ForwardRef as ReactComponent };